export default (($) => {

    return function() {

        const tabs = document.querySelectorAll('.button-tabs__tab');
        const tabsArr = Array.from(tabs);
        var hashtag = window.location.hash;
        
        // The tab switching function
        const switchTab = (oldTab, newTab) => {

            //find this newTab panels and tab group
            let tabHeadlines = newTab.closest('.js-tabs-container').querySelectorAll('.tab-top-title');
            let tabGroup = newTab.closest('.js-tabs-container').querySelectorAll('.button-tabs__tab');
            let panels = newTab.closest('.js-tabs-container').querySelectorAll('[role="tabpanel"]');

            newTab.focus();
            // Make the active tab focusable by the user (Tab key)
            newTab.removeAttribute('tabindex');
            // Set the selected state
            newTab.setAttribute('aria-selected', 'true');
            oldTab.setAttribute('aria-selected', 'false');
            
            // oldTab.removeAttribute('aria-selected');
            oldTab.setAttribute('tabindex', '-1');
            // Get the indices of the new and old tabs to find the correct
            // tab panels to show and hide
            let index = Array.prototype.indexOf.call(tabGroup, newTab);
            let oldIndex = Array.prototype.indexOf.call(tabGroup, oldTab);

            window.location.hash = newTab.getAttribute("href");
            
            panels[oldIndex].hidden = true;
            panels[index].hidden = false;

            tabHeadlines[oldIndex].hidden = true;
            tabHeadlines[index].hidden = false;
        }

        //loop through all tabs
        tabsArr.forEach( (tab, i) => {

            // Handle clicking of tabs for mouse users
            tab.addEventListener('click', e => {
                e.preventDefault();
                let currentTab = tab.closest('.button-tabs').querySelector('[aria-selected="true"]');
                if (e.currentTarget !== currentTab) {
                    switchTab(currentTab, e.currentTarget);
                }
            });

            // Handle keydown events for keyboard users
            tab.addEventListener('keydown', e => {
                // Get the index of the current tab in the tabs node list
                let targetGroup = tab.closest('.button-tabs').querySelectorAll('.button-tabs__tab');
                let targetPanels = tab.closest('.js-tabs-container').querySelectorAll('[role="tabpanel"]');

                let index = Array.prototype.indexOf.call(targetGroup, e.currentTarget);
                
                // Work out which key the user is pressing and
                // Calculate the new tab's index where appropriate
                //console.log(e.which);
                let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
                if (dir !== null) {
                    e.preventDefault();
                    // If the down key is pressed, move focus to the open panel,
                    // otherwise switch to the adjacent tab
                    dir === 'down' ? targetPanels[index].focus() : targetGroup[dir] ? switchTab(e.currentTarget, targetGroup[dir]) : void 0;
                }
            });

        });

        //handle active tab when hashtag is set
        if( hashtag ){

            hashtag = hashtag.replace('#','');
            let buttonTabId = 'bt-' + hashtag;

            let newTab = document.getElementById(buttonTabId);

            //if this is a tab that exists
            if( newTab ){
                //current tab from this button tab group
                let currentTab = newTab.closest('.button-tabs').querySelector('[aria-selected]'); 
                //only switch the tab if the new one is not already current
                if ( newTab !== currentTab ) {
                    switchTab(currentTab, newTab);
                }
            }
        }


    }

})(jQuery)